import { LOCALES } from "./locales";

export const CURRENCY = {
    USD: "USD",
    VND: "VND",
    KRW: "KRW",
};

export const LOCALE_BY_CURRENCY = {
    [CURRENCY.USD]: { locale: LOCALES.ENUS, minimumFractionDigits: 0, maximumFractionDigits: 2 },
    [CURRENCY.KRW]: { locale: LOCALES.KOKR, minimumFractionDigits: 0, maximumFractionDigits: 0 },
    [CURRENCY.VND]: { locale: LOCALES.ENUS, minimumFractionDigits: 0, maximumFractionDigits: 0 },
};

export const FRACTIONAL_CURRENCIES = [CURRENCY.USD];

export const DISPLAY_ROUNDING_UNIT = {
    [CURRENCY.USD]: 0,
    [CURRENCY.KRW]: 100,
    [CURRENCY.VND]: 1000,
};
